// Site Configuration - QasabaEnergy Rebrand
export const siteConfig = {
  name: 'Qasaba Energy',
  tagline: 'Clean Energy Now',
  email: 'inquiries@qasabaenergy.com',
  address: {
    line1: '26th Floor',
    line2: 'Al Fardan Tower',
    city: 'Doha',
    country: 'Qatar'
  }
};

// Images - Using high-quality stock images for reliable loading
export const images = {
  heroBg: 'https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?w=1920&q=80',
  missionGraphic: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=400&q=80',
  videoPoster: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=1200&q=80',
  howH2: 'https://images.unsplash.com/photo-1673245886420-f01f958586df?w=1200&q=80',
  howGraphite: 'https://images.unsplash.com/photo-1637681241471-de08fe750e94?w=1200&q=80',
  about1: 'https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?w=1200&q=80',
  about2: 'https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=1200&q=80',
  about3: 'https://images.unsplash.com/photo-1532601224476-15c79f2f7a51?w=1200&q=80',
  about4: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=1200&q=80',
  ctaBg: 'https://images.unsplash.com/photo-1518173946687-a4c036bc1c9a?w=1920&q=80',
  advisoryHero: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&q=80',
  appendixHero: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=1920&q=80',
  logoSymbol: 'https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=100&q=80',
  greenhouse: 'https://images.unsplash.com/photo-1611273426858-450d8e3c9fce?w=100&q=80',
  greenhouseBg: 'https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=1920&q=80',
  // Advisory member images
  member1: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=500&fit=crop',
  // Technology images
  howIt2: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=800&q=80',
  // Application fields
  field1: 'https://images.unsplash.com/photo-1532601224476-15c79f2f7a51?w=400&q=80',
  field2: 'https://images.unsplash.com/photo-1593941707882-a5bba14938c7?w=400&q=80',
  field3: 'https://images.unsplash.com/photo-1565793298595-6a879b1d9492?w=400&q=80',
  field4: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=400&q=80',
  field5: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400&q=80',
};

export const navigation = [
  { name: 'Home', path: '/' },
  { name: 'Advisory', path: '/advisory' },
  { name: 'Appendix', path: '/appendix' },
];

export const heroContent = {
  title: 'Qasaba Quantum Reformer™ (QQR™) transforms any hydrocarbon into',
  highlight: 'clean energy',
  titleEnd: 'now.'
};

export const missionContent = {
  label: 'Our Mission',
  text: 'Our mission is to serve the world by delivering clean hydrogen and high-grade graphite with zero emissions.',
  showreel: 'Showreel 2023',
  playText: 'Play Video',
  videoUrl: '' // Video removed - was linked to original brand
};

export const howItWorksContent = {
  label: 'How it works',
  title: 'No Emissions,',
  titleHighlight: 'No Waste.',
  items: [
    {
      label: 'The Process',
      text: 'The patented Qasaba Quantum Reformer™ (QQR™) leverages the current fossil industry infrastructure and resources (coal, natural gas, oil, biomass, or blend) to produce clean-burning hydrogen (Quantum H2™) and high-grade graphite (Quantum Graphite™). QQR™ superheats hydrocarbons to nearly half the temperature of the sun\'s surface, causing them to instantly break down into elemental hydrogen and solid carbon particles.'
    },
    {
      label: 'The Plan',
      text: 'Due to its modular design, retrofitting existing power plants with QQR™ enables the efficient and clean burning of hydrogen fuel — eliminating millions of metric tons of greenhouse gas emissions per retrofitted power plant per year, and offering a pragmatic and significantly faster path forward in the clean energy transition.'
    }
  ],
  products: [
    {
      title: 'Quantum H₂™',
      subtitle: 'Clean hydrogen energy',
      description: 'Aside from being the most abundant element in the known universe, creating hydrogen that can be used for fuel involves numerous processes that range from green to black. Our unique Quantum H₂™ creates clean energy with zero emissions and no incremental cost, a first in the industry.'
    },
    {
      title: 'Quantum Graphite™',
      subtitle: 'High-grade graphite with zero emissions',
      description: 'Our process creates Quantum Graphite™, a high-grade graphite composed of a high percentage of graphene. Graphene is an extraordinary material that is just one atom thick, two hundred times stronger than steel, light as paper, and conducts electricity better than copper. This critical mineral is used in everything from electric vehicle batteries to steel to super strong cement.'
    }
  ]
};

export const aboutContent = {
  note: 'The first of many clean energy conversions, our retrofitting of the Al Fardan Power Station in Doha, Qatar, began in August 2023.',
  title: 'Zero-emissions energy isn\'t a projection. It\'s here now.',
  subtitle: 'We can achieve clean energy initiatives now while bolstering local economies in the future.',
  cta: 'Go deeper',
  ctaLink: '/appendix',
  benefits: [
    {
      title: 'Job preservation and creation:',
      text: 'By plugging QQR™ into existing power stations, we\'re preserving local jobs and creating new opportunities in hydrogen and graphite production.'
    },
    {
      title: 'Reduction of greenhouse gases:',
      text: 'We engineered the process to eliminate 100% of the harmful CO2, reducing GHG emissions by 3,214,000 metric tons per power plant per year.'
    },
    {
      title: 'Strengthening energy supply chains:',
      text: 'Through our process, we\'re providing high-grade Quantum Graphite™ to supply chains at low cost with zero emissions.'
    },
    {
      title: 'Consumer savings:',
      text: 'By using existing infrastructure, there is no added cost to the consumer for energy.'
    }
  ]
};

export const advisoryCtaContent = {
  title: 'Meet the guiding force behind Qasaba.',
  cta: 'Meet the Board',
  ctaLink: '/advisory'
};

export const comparisonContent = {
  from: {
    label: 'From:',
    items: [
      'Clean energy as luxury',
      'Accessible to few',
      'Too unattainable',
      'Cost prohibitive',
      'Scarcity',
      'Ideology',
      'Possible someday',
      'Crisis of our generation',
      'Too good to be true',
      'Dirty fuel sources',
      'Harmful greenhouse gas',
      'Necessary evil'
    ]
  },
  to: {
    label: 'To QASABA:',
    items: [
      'Clean energy as utility',
      'Affordable for all',
      'Readily available',
      'Cost effective',
      'Abundance',
      'Reality',
      'Happening now',
      'Discovery of a lifetime',
      'Too incredible to ignore',
      'Pure clean energy material',
      'Zero emissions',
      'Societal good'
    ]
  }
};

export const pressContent = {
  label: 'Press',
  title: 'Latest News.',
  articles: [
    {
      source: 'Qatar Tribune',
      title: 'Qasaba Energy unveils pilot program at Al Fardan Power Station',
      image: 'https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?w=600&q=80',
      link: '#'
    },
    {
      source: 'Press Release',
      title: 'Qasaba Energy Joins $20 Million Initiative to Revolutionize Clean Energy',
      image: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=600&q=80',
      link: '#'
    },
    {
      source: 'Energy Forum',
      title: "View Dr. Ahmed Al-Rashid's presentation on 'Re-Inventing Power Generation' from this year's Gulf Energy Conference.",
      image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600&q=80',
      link: '#'
    },
    {
      source: 'Press Release',
      title: 'Dr. Al-Rashid to Discuss Qasaba Energy Converting Fossil Fuels to Hydrogen and Valuable Graphite - a Project of Firsts',
      image: 'https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=600&q=80',
      link: '#'
    },
    {
      source: 'QRI Group',
      title: 'Oil and Gas Offer Practical Path to Zero Emissions',
      image: 'https://images.unsplash.com/photo-1466611653911-95081537e5b7?w=600&q=80',
      link: '#'
    },
    {
      source: 'Gulf News',
      title: 'Al Fardan Power transfer to Qasaba finalized',
      image: 'https://images.unsplash.com/photo-1532601224476-15c79f2f7a51?w=600&q=80',
      link: '#'
    },
    {
      source: 'Doha Times',
      title: 'Qasaba Energy Marks Early Success With Clean Electricity Demonstration That Records Several World Firsts',
      image: 'https://images.unsplash.com/photo-1558449028-b53a39d100fc?w=600&q=80',
      link: '#'
    }
  ]
};

export const ctaContent = {
  text: 'This is what the future looks like. Let\'s work together.',
  cta: 'Contact Us'
};

export const advisoryContent = {
  title: 'Advisory Board.',
  subtitle: 'With an immense knowledge of the industry and a deep understanding of the science, we\'ve come together to help Qasaba deliver net-zero energy now.',
  members: [
    {
      name: 'Douglas Quezada',
      title: 'Chairman',
      bio: 'Douglas Quezada serves as Chairman of Qasaba Energy, bringing decades of leadership experience in energy innovation and strategic business development. His vision and guidance have been instrumental in positioning Qasaba at the forefront of clean energy transformation.',
      image: '/images/douglas-quezada.jpeg'
    },
    {
      name: 'Mohammed Alexander',
      title: 'Vice Chairman',
      bio: 'Mohammed Alexander serves as Vice Chairman of Qasaba Energy, playing a crucial role in shaping the company\'s strategic initiatives and corporate governance.',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=500&fit=crop'
    },
    {
      name: 'Richard Haws',
      title: 'Managing Director',
      bio: 'Richard Haws serves as Managing Director of Qasaba Energy, responsible for the day-to-day operations and execution of the company\'s strategic vision.',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=500&fit=crop'
    },
    {
      name: 'Naru',
      title: 'Chief Financial Officer (CFO)',
      bio: 'Naru serves as Chief Financial Officer of Qasaba Energy, overseeing all financial operations, strategic planning, and investor relations.',
      image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=500&fit=crop'
    }
  ]
};

export const appendixContent = {
  hero: {
    label: 'The Impact',
    title: 'Go deeper.'
  },
  sections: [
    {
      id: 'jobs',
      title: 'Job preservation & creation.',
      content: 'By integrating our Qasaba Quantum Reformer™ (QQR™) into existing power plants, we preserve local jobs and create new opportunities. The Al Fardan Power Station in Doha broke ground in August 2023 and is expected to be operational by 2025/2026. By explicitly retrofitting the power station, we preserved over 1200 local jobs while creating new opportunities for graphite production and ongoing energy innovation.',
      techLabel: 'Qasaba Quantum Reformer™ technology',
      locationLabel: 'The Al Fardan Power Station in Doha'
    },
    {
      id: 'emissions',
      title: 'Elimination of greenhouse gasses.',
      content: 'The Al Fardan Power Station broke ground in August 2023 and is expected to be operational by 2025. By retrofitting the power station with the Qasaba Quantum Reformer™, we are generating ~78 MTPH and producing over 0.6 Millions MT of Quantum H2™ annually. We have also preserved over 1200 local jobs while creating new opportunities for graphite production and ongoing energy innovation.',
      graphiteContent: 'Through our process, we produce Quantum Graphite™ by capturing the carbon that would have otherwise been released into the air. Annually, our plant will produce 6.1 million tons of graphite (captured carbon) which is equivalent to capturing and storing 24.4 million tons of CO2.',
      note: 'These efforts contribute significantly to environmental sustainability and support the transition towards a zero emissions economy.'
    },
    {
      id: 'supply',
      title: 'Strengthening energy supply chains.',
      intro: 'Fields of application:',
      content: 'At our retrofitted power plant, we can produce high-grade Quantum Graphite™ at a low cost with no emissions. This allows us to deliver the highest quality graphite, an essential element for more eco-friendly manufacturing of cement, steel, electric car batteries, reactors and many more other industrial applications.',
      applications: [
        { name: 'Eco-Friendly Steel and Concrete', image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=400&q=80' },
        { name: 'Refractories', image: 'https://images.unsplash.com/photo-1565793298595-6a879b1d9492?w=400&q=80' },
        { name: 'Electrodes', image: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=400&q=80' },
        { name: 'Electric Car Batteries', image: 'https://images.unsplash.com/photo-1593941707882-a5bba14938c7?w=400&q=80' },
        { name: 'Nuclear reactors', image: 'https://images.unsplash.com/photo-1532601224476-15c79f2f7a51?w=400&q=80' }
      ],
      note: 'The use of graphite in various industrial applications offers numerous benefits, including reduced GHG emissions, promotion of low-emission manufacturing, enhanced energy efficiency, and technological advancements. It\'s not just the industries that benefit. By utilizing the existing energy infrastructure, there is no added cost or lifestyle changes required by the consumer.'
    }
  ]
};
